<template>
  <div v-if="results" class="spelling">
    <b-alert v-if="response && response.numFound == 0" variant="primary" show>{{$t('paging.no_results')}}.

    <span v-if="spelling"> {{$t('spelling.did_you_mean')}}: </span>
    <b-badge v-for="suggestion in spelling" :key="suggestion.suggestion"  variant="secondary" pill href="#" v-on:click.prevent="onSuggestionSelected(suggestion)">
      {{ suggestion.suggestion }}</b-badge>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'spelling',
  data () {
    return {
    }
  },
  methods: {
    onSuggestionSelected (item) {
        this.$router.push(item.sem_action.sem_url_action);
    }
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    results () {
      if (this.$store.state.response &&
          this.$store.state.response.response &&
          this.$store.state.response.response.docs) {
        return this.$store.state.response.response.docs
      }
      return null;
    },
    spelling () {
      if (this.$store.state.response &&
        this.$store.state.response.spelling &&
        this.$store.state.response.spelling.suggestions) {

        return this.$store.state.response.spelling.suggestions;
      }
      return null;
    }
  }
}
</script>

<style>
  .spelling .badge {
    margin-right: 2px;
  }
</style>
